
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warunki-narciarskie",
      function () {
        return require("private-next-pages/warunki-narciarskie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warunki-narciarskie"])
      });
    }
  